import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

type Props = {
    error: string | null;
    onClose: () => void;
};

/**
 * Reusable error dialog component for displaying error messages.
 * Shows a modal dialog with the error message and an OK button to dismiss.
 */
export function ErrorDialog({ error, onClose }: Props) {
    return (
        <Dialog open={error !== null} onClose={onClose} sx={{ zIndex: 10001 }}>
            <DialogTitle>Error</DialogTitle>
            <DialogContent>
                <DialogContentText>{error}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* oxlint-disable-next-line jsx-a11y/no-autofocus */}
                <Button onClick={onClose} variant="contained" autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
